import { ref } from 'vue'

export const otpValide = ref(false)
